import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { StyledDrawer } from '@fuww/library/src/Drawer';
import { DrawerContent } from './SimpleDrawer';

const drawerProperties = {
  open: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
};

type DrawerProperties = InferProps<typeof drawerProperties>;

const Drawer = ({ open, closeDrawer } : DrawerProperties) => (
  <StyledDrawer
    open={open}
    onClose={closeDrawer}
  >
    <DrawerContent closeDrawer={closeDrawer} />
  </StyledDrawer>
);

Drawer.propTypes = drawerProperties;

export default Drawer;
